import { formatDateWithTime } from "helpers/DateUtils";
import IContainerStatus from "interfaces/IContainerStatus";
import IContainerStatusViewModel from "interfaces/IContainerStatusViewModel";

const dummyWorkOrderReferences: {containerId : string, workOrderReference : string}[] = [
  { containerId: "ATS|41", workOrderReference: "ATS000017" },
  { containerId: "ATS|42", workOrderReference: "ATS000021" }

];

function mapContainerStatusToContainerStatusViewModel(
  containerStatus: IContainerStatus
): IContainerStatusViewModel {
  const containerStatusViewModel: IContainerStatusViewModel = {
    id: containerStatus.id,
    name: containerStatus.name,
    region: containerStatus.region?.name,
    regionId: containerStatus.region?.id,
    hwrcSite: containerStatus.hwrcSite?.name,
    size: containerStatus.size,
    fillLevel: containerStatus.fillLevel,
    aboveThreshold: containerStatus.aboveThreshold,
    wasteTypeId: containerStatus.wasteTypeId,
    wasteType: containerStatus.wasteType,
    workOrderReferenceNumber: containerStatus.workOrderReferenceNumber,
    lastUpdatedTimestamp: containerStatus.lastUpdatedTimestamp ? new Date(containerStatus.lastUpdatedTimestamp) : undefined,
    regionHwrcSiteSortOrder: `${containerStatus.hwrcSite.name}, ${containerStatus?.region?.name}`
  };

  return containerStatusViewModel;
}

function mapContainerStatusesToContainerViewStatusModels(
  containerStatuses: IContainerStatus[] | null
): IContainerStatusViewModel[] {
  const containerStatusesViewModels: IContainerStatusViewModel[] = [];

  if (containerStatuses) {
    containerStatuses.forEach((containerStatus): void => {
      containerStatusesViewModels.push(
        mapContainerStatusToContainerStatusViewModel(containerStatus)
      );
    });
  }

  return containerStatusesViewModels;
}

export {
  mapContainerStatusesToContainerViewStatusModels
};
